import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["manualInput"];

  connect() {
    this.initializeScanner();
  }

  disconnect() {
    if (this.scanner) {
      this.scanner.stop();
    }
  }

  initializeScanner() {
    // TODO: Integrate with a QR scanner library (e.g., @zxing/library or html5-qrcode)
    // For now, simulate scanner initialization
    console.log("QR Scanner initialized (simulation)");
  }

  manualSubmit(event) {
    event.preventDefault();
    const qrData = this.manualInputTarget.value.trim();

    if (!qrData) {
      this.showError("Veuillez saisir un code QR valide");
      return;
    }

    this.submitQrData(qrData);
  }

  submitQrData(qrData) {
    const formData = new FormData();
    formData.append('qr_data', qrData);

    fetch(this.element.closest('[data-teacher-attendance-pointing-qr-pointings-url-value]').dataset.teacherAttendancePointingQrPointingsUrlValue, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      }
    })
    .then(response => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Submission failed');
      }
    })
    .then(html => {
      // Handle Turbo stream response
      if (html.includes('turbo-stream')) {
        window.Turbo.renderStreamMessage(html);
      }
    })
    .catch(error => {
      console.error('QR submission error:', error);
      this.showError("Erreur lors de la soumission du QR code");
    });
  }

  showError(message) {
    // TODO: Implement proper error display (e.g., via flash or modal content)
    alert(message);
  }
}
